import { assetsUrl } from '@awork/environments/environment'
import isTest from '@awork/_shared/functions/is-test'
import { setGlobalQ } from '@awork/_shared/functions/global-variables'
import type { Language } from '@awork/_shared/functions/get-language'
import getLanguage from '@awork/_shared/functions/get-language'
import type { ISOLanguage } from '@awork/_shared/models/account.model'
import * as deTranslationFile from '../../../assets/i18n/de.json'
import * as enTranslationFile from '../../../assets/i18n/en.json'
/**
 * Loads the translation file and assigns it to the `q` global variable.
 * @returns {() => Promise<void>}
 */
export function fetchTranslation(): () => Promise<void> {
  return async () => {
    const languageObj = {
      language: getLanguage() as Language,
      iso: getLanguage(true) as ISOLanguage
    }

    if (globalThis.q?.translations.currentLang) {
      if (globalThis.q.translations.currentLang !== languageObj.iso && !isTest()) {
        // TODO: Reload page to fetch the correct language, temp fix
        window.location.reload()
      }

      return
    }

    const translationFile = languageObj.language === 'de' ? deTranslationFile : enTranslationFile
    const translations = {
      ...(translationFile as unknown as QTranslations),
      currentLang: languageObj.iso
    } as QTranslations

    setGlobalQ({ translations, assetsUrl })
  }
}
